import { MeldType } from './types';

export interface RuleConfig {
  minHuxiToWin: number;
  allowJiaoChi: boolean;
  allowJiaoHu: boolean;
  redCardValues: number[];
  huxi: Record<MeldType, { big: number; small: number }>;
}

export const DEFAULT_RULE_CONFIG: RuleConfig = {
  minHuxiToWin: 15,
  allowJiaoChi: true,
  allowJiaoHu: true,
  redCardValues: [2, 7, 10],
  huxi: {
    TI: { big: 12, small: 9 },
    PAO: { big: 9, small: 6 },
    KAN: { big: 6, small: 3 },
    SAO: { big: 6, small: 3 },
    PENG: { big: 3, small: 1 },
    CHI_123: { big: 6, small: 3 },
    CHI_2710: { big: 6, small: 3 },
    CHI_SEQ: { big: 0, small: 0 },
    CHI_JIAO: { big: 0, small: 0 },
    PAIR: { big: 0, small: 0 }
  }
};

export function resolveRuleConfig(config?: Partial<RuleConfig>): RuleConfig {
  if (!config) return DEFAULT_RULE_CONFIG;
  return {
    ...DEFAULT_RULE_CONFIG,
    ...config,
    huxi: { ...DEFAULT_RULE_CONFIG.huxi, ...config.huxi },
    redCardValues: config.redCardValues ? [...config.redCardValues] : DEFAULT_RULE_CONFIG.redCardValues
  };
}